// extracted by mini-css-extract-plugin
module.exports = {"type-select":"type-select___NV4Ta","type-input-label":"type-input-label___3KmR7","map-block":"map-block___30FXY"};